<template lang="pug">
#app
  the-nav
  #wrapper
    router-view
  the-footer
</template>

<script>
import TheNav from "@/components/TheNav.vue";
import TheFooter from "@/components/TheFooter.vue";

export default {
  name: "App",
  components: {
    TheNav,
    TheFooter
  }
};
</script>

<style lang="sass">
@import "~bulma"
@import "~buefy/src/scss/buefy"

#nav
  padding: 30px
  a
    font-weight: bold
    color: #2c3e50
    &.router-link-exact-active
      color: #42b983

.app-full-height
  +size(100%, 100vh)

.app-section-title-divider
  width: pxRem(86)
  height: pxRem(8)
  background-color: $info
  border-radius: 3px
  margin-bottom: pxRem(24)

.app-m-auto
  margin: auto

.app-text
  line-height: 1.9
  letter-spacing: pxRem(1.9)
</style>
